import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-camera" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_UploadAvatarForm = _resolveComponent("UploadAvatarForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Avatar, {
      shape: 'circle',
      icon: !_ctx.avatarURL ? _ctx.icon : '',
      image: _ctx.avatarURL,
      label: _ctx.avatarLabel,
      class: _normalizeClass({
      'p-avatar-large': _ctx.isLarge,
      'is-text-avatar': _ctx.avatarLabel,
      'is-icon-avatar': _ctx.icon,
      'is-editable': _ctx.isEditable
    }),
      onClick: _ctx.showUploadOptions
    }, null, 8, ["icon", "image", "label", "class", "onClick"]),
    (_ctx.isEditable && _ctx.avatarURL)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "c-avatar-camera",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showUploadOptions && _ctx.showUploadOptions(...args))),
          onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showUploadOptions && _ctx.showUploadOptions(...args)))
        }, _hoisted_2, 32))
      : _createCommentVNode("", true),
    (_ctx.isEditable)
      ? (_openBlock(), _createBlock(_component_OverlayPanel, {
          key: 1,
          ref: "avatarOptions",
          class: "c-avatar-options-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              label: "Upload Avatar",
              icon: "pi pi-upload",
              onClick: _ctx.showUploadForm
            }, null, 8, ["onClick"]),
            _createVNode(_component_base_button, {
              label: "Clear avatar",
              class: "warning-transparent",
              icon: "pi pi-trash",
              onClick: _ctx.clearAvatar
            }, null, 8, ["onClick"]),
            _createVNode(_component_base_button, {
              label: "Cancel",
              class: "transparent",
              onClick: _ctx.closeUploadOptions
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true),
    _createVNode(_component_UploadAvatarForm, {
      ref: "uploadForm",
      onAvatarUpdated: _ctx.onAvatarUpdated
    }, null, 8, ["onAvatarUpdated"])
  ], 64))
}